import { Injectable } from "@angular/core";
import { UserService } from "./core/user/user.service";
import { SentryErrorHandler } from "@sentry/angular-ivy";


@Injectable()
export class AppErrorHandler extends SentryErrorHandler {

    constructor(private _userService: UserService) {
        super({ showDialog: false });
    }

    handleError(error: any) {
        const chunkFailedMessage = /Loading chunk [a-zA-Z\d_.-]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            this._userService.appNeedsUpdate = true;
        } else {
            super.handleError(error);
        }

    }
}
